import { Component, Input, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNItem } from 'src/app/models/cnitem';
import { CNPrescription } from 'src/app/models/cnprescription';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { PrescriptionService } from 'src/app/services/prescription.service';
import { UserOpenItemsService } from 'src/app/services/user-open-items.service';

@ManageType('PrescriptionPanelComponent')
@Component({
  selector: 'app-prescription-panel',
  templateUrl: './prescription-panel.component.html',
  styleUrls: ['./prescription-panel.component.scss']
})
export class PrescriptionPanelComponent implements OnInit {

  @Input() prescription: CNPrescription;

  constructor(private prescriptions: PrescriptionService, private userOpenItems: UserOpenItemsService) { }

  ngOnInit(): void {
  }

  /**
   * ItemComponent interface
   */

  @Input() set item(anitem: CNItem) {
    if (anitem instanceof CNPrescription) {
      this.prescription = anitem;
    }
  }

  addEntry(entry: CNPrescriptionEntry) {
    this.prescription.addChild(entry, false).subscribe();
  }

  save() {
    if (this.prescription.id !== 0) {
      const updateSub = this.prescriptions.updatePrescription(this.prescription).subscribe(() => {
        updateSub.unsubscribe();
        this.userOpenItems.removeItem(this.prescription);
      });
    }
  }

}
